import React from "react";
import { getAllClientInvoices } from "../../services/finance";
import { Breadcrumbs } from "../inventory/components/Breadcrumbs";
import BasicTable from "../../components/BasicTable";
import { useCookiesContext } from "../../contexts/CookiesContext";
import { financesBreadcrumbs as breadcrumbs } from "@revbox/localization";

const colWidth = {
  amount: 100,
  account_id: 100,
  campaign_id: 100,
  invoice_no: 100,
  user_email: 100,
  first_name: 100,
  vat_number_valid: 100,
  invoice_address_country_id: 100,
  due_date: 100,
};

const hiddenColumns = [];

const rowFields = [
  "id",
  "amount",
  "account_id",
  "campaign_id",
  "invoice_no",
  "user_email",
  "first_name",
  "last_name",
  "invoice_address_country_id",
  "due_date",
]

export default function Invoices() {
  const { getLanguageAbbr, getSkinMode } = useCookiesContext();
  const language = getLanguageAbbr();

  const title = breadcrumbs[language].invoices
  const breadcrumb = breadcrumbs[language].finances
  const edit_redirect = "/pub/finance/invoice/preview"
  const breadcrumb_redirect = "/pub/invoices"

  const currentSkin = getSkinMode();

  return (
    <React.Fragment>
      <div className="main main-app d-flex flex-column p-3 p-lg-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <Breadcrumbs breadcrumb={breadcrumb} breadcrumb_redirect={breadcrumb_redirect} title={title} />
        </div>

        <BasicTable getData={getAllClientInvoices} url={edit_redirect} hiddenColumns={hiddenColumns} colWidth={colWidth} rowFields={rowFields} skin={currentSkin} />

        
      </div>
    </React.Fragment>
  )
}